module.exports = __webpack_public_path__ + "static/flex_desk_2-08f4f9ec8df196b34c90b006af771385.jpg";